import { BaseAPI } from "../base/service";
import { CourseType } from "../enums";
import { LongExamResolution } from "./dto";

export class LongExamResolutionAPI extends BaseAPI {
    private year: number = new Date().getFullYear();

    public getList(type: CourseType): Promise<LongExamResolution[]> {
        return this.api.get(`/${type}/${this.year}/long-exam-resolution/`);
    }
}